/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BalaneTypesEnum = "Deposit_Cash" | "Grant_Cash" | "Winning_Cash" | "%future added value";
export type WalletTransactionCashType = "GRANT_MONEY" | "TOP_UP" | "WINNING_CASH" | "%future added value";
export type WalletTransactionTransactionType = "CREDIT" | "DEBIT" | "%future added value";
export type WalletTransactionHistoryByBalanceTypeQueryVariables = {|
  balanceType?: ?BalaneTypesEnum
|};
export type WalletTransactionHistoryByBalanceTypeQueryResponse = {|
  +walletTransactionsFilter: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +transactionType: WalletTransactionTransactionType,
        +amount: ?number,
        +created: any,
        +cashType: WalletTransactionCashType,
        +description: string,
      |}
    |}>
  |}
|};
export type WalletTransactionHistoryByBalanceTypeQuery = {|
  variables: WalletTransactionHistoryByBalanceTypeQueryVariables,
  response: WalletTransactionHistoryByBalanceTypeQueryResponse,
|};
*/


/*
query WalletTransactionHistoryByBalanceTypeQuery(
  $balanceType: BalaneTypesEnum
) {
  walletTransactionsFilter(balanceType: $balanceType) {
    edges {
      node {
        id
        transactionType
        amount
        created
        cashType
        description
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "balanceType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "balanceType",
        "variableName": "balanceType"
      }
    ],
    "concreteType": "WalletTransactionNodeConnection",
    "kind": "LinkedField",
    "name": "walletTransactionsFilter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletTransactionNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletTransactionNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transactionType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "amount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cashType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WalletTransactionHistoryByBalanceTypeQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WalletTransactionHistoryByBalanceTypeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "18af1648f3fa61cb738297e6ab7aa565",
    "id": null,
    "metadata": {},
    "name": "WalletTransactionHistoryByBalanceTypeQuery",
    "operationKind": "query",
    "text": "query WalletTransactionHistoryByBalanceTypeQuery(\n  $balanceType: BalaneTypesEnum\n) {\n  walletTransactionsFilter(balanceType: $balanceType) {\n    edges {\n      node {\n        id\n        transactionType\n        amount\n        created\n        cashType\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '71e00480f91fc767bc22231605e0ef2a';

module.exports = node;
